module.exports = __webpack_public_path__ + "img/8.18c58d2c.jpg";